/*
 *   File : rebalance-log.js
 *   Author : https://evoqins.com
 *   Description : Audit trails & rebalance log data tab file
 *   Integrations : 'react-toastify'
 *   Version : 1.0.0
*/

// custom packages
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

// custom components
import { CustomDataTable } from '../../../Components/DataTable';
import { Icon } from '../../../Components/Icon';
import { TextButton } from '../../../Components/Buttons';
import { APIService } from '../../../Service';
import { EmptyScreen } from '../../../Components/Others';


const RebalanceLog = () => {

    const { id } = useParams();
    const isRendered = useRef(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [auditTrails, setAuditTrails] = useState({});
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        if (isRendered.current === true) {
            _getAuditTrails();
        }
        isRendered.current = false;
    }, []);

    // handle table page change 
    const _handleTablePageChange = (page_num) => {
        setCurrentPage(page_num);
    };

    // Pending request data table column 
    const AUDIT_TRAIL_TABLE_COLUMN = [
        {
            name: 'Timestamp',
            selector: row => row.date_time,
            width: "210px"
        },
        // {
        //     name: 'User/Admin',
        //     cell: (row) =>
        //         <span className=''
        //         >
        //             {row.user_type}
        //         </span>,
        //     width: "120px"
        // },
        // {
        //     name: 'Action',
        //     selector: row => row.activity_type,
        //     width: "160px"
        // },
        // {
        //     name: 'Details',
        //     cell: (row) =>
        //         <p className='mb-0 line-height-22px truncate-second-line'>
        //             {row.activity_description}
        //         </p>,
        //     width: "300px"
        // },
        {
            name: 'Request',
            cell: (row) =>
                <>
                    {row.api}
                </>,
            width: "300px"
        },
        {
            name: 'IP address',
            selector: row => row.ip_address,
            width: "200px"
        },
        // {
        //     name: 'Status',
        //     selector: row => row.status,
        //     width: "140px"
        // },
    ];


    // API - audit trails
    const _getAuditTrails = () => {
        let is_post = true;
        // let url = 'user/account-activity';
        let url = 'user/account-activity-report'
        let request = {
            "customer_id": id,
            // "page_num": currentPage,
            // "page_size": 10
            "date_to": null,
            "date_from": null
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setAuditTrails(response.data);
            }
            else {
                setAuditTrails({ data: [] });
            }
            setLoader(false);
        })
    };

    return (
        <Fragment>
            <div className='padding-32px-top padding-32px-lr pb-4'>
                {/*Audit trail list */}
                <h6 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                    Audit trail list
                </h6>
            </div>

            {/* Audit trail data table list */}
            {loader === true ?
                <div className='d-flex align-items-center justify-content-center min-vh-100'>
                    <img src={require("../../../Assets/Image/loader.gif")}
                        draggable={false}
                        width={80}
                        height={80}
                        alt='loader'
                        className='text-center' />
                </div>
                :
                auditTrails.data.length > 0 ?
                    <div className='e-data-table-wrapper-default-updated padding-42px-bottom'>
                        <CustomDataTable columns={AUDIT_TRAIL_TABLE_COLUMN}
                            data={auditTrails.data}
                            pagination={auditTrails.total_count > 10 ? true : false}
                            paginationPerPage={10}
                            paginationTotalRows={auditTrails.total_count}
                            paginationDefaultPage={auditTrails.current_page}
                            lastPage={auditTrails.total_page}
                            onChangePage={_handleTablePageChange} />
                    </div>
                    :
                    <EmptyScreen
                        image={require('../../../Assets/Image/NotFound/no-data.png')}
                        title='No results found'
                        className="min-vh-100"
                        description={`We couldn't find anything that matches your search. Try checking your spelling, using different keywords, or exploring popular funds.`}
                    />

            }

            {/* Pending actions */}
            {/* <div className='padding-32px-lr pb-5'>
                <h6 className='mb-4 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                    Pending actions
                </h6>
                <div className='row'>
                    <div className='col-6'>
                        <div className='d-flex gap-12px align-items-start e-bg-cornsilk border-radius-8 p-4'>
                            <div>
                                <Icon icon="info"
                                    size="1rem"
                                    className="d-flex margin-2px-top" />
                            </div>
                            <div>
                                <p className='mb-2 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                    Rebalance pending: Awaiting customer confirmation
                                </p>
                                <p className='mb-3 e-text-smoky-black e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                    Date initiated: 23 Jan 2024
                                </p>
                                <TextButton name="Send Reminder"
                                    className="e-font-16 line-height-20px" />
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

        </Fragment>
    )
}

export default RebalanceLog;
